/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { ILinksData } from '../../..';

export interface IB2bRequestsTileLinksProps {
    links: ILinksData[];
    requestContext: Msdyn365.IRequestContext;
    /** The telemetry content */
    telemetryContent?: ITelemetryContent;
    onTextChange?(index: number): (event: Msdyn365.ContentEditableEvent) => void;
}

const defaultClassName = 'ms-account-b2b-requests-tile';

export const B2bRequestsTileLinks: React.FC<IB2bRequestsTileLinksProps> = ({ links, telemetryContent, onTextChange, requestContext}) => {

    if (!ArrayExtensions.hasElements(links)) {
        return null;
    }
    const editableLinks = _mapEditableLinks(links, telemetryContent);
    return (
        <div className={`${defaultClassName}__links`}>
            { ArrayExtensions.hasElements(editableLinks) ?
                    <Msdyn365.Links
                        links= {editableLinks}
                        editProps={{onTextChange: onTextChange, requestContext: requestContext}}
                    />
                    : null
                }
        </div>
    );
};

const _mapEditableLinks = (linkdata: ILinksData[], telemetryContent?: ITelemetryContent): Msdyn365.ILinksData[] | null => {
    if(!ArrayExtensions.hasElements(linkdata)) {
        return null;
    }

    const payLoad = getPayloadObject('click', telemetryContent!, '');

    return linkdata.map((link) => {
        payLoad.contentAction.etext = link.linkText;
        const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
        return {
            ariaLabel: link.ariaLabel,
            className: `${defaultClassName}__link`,
            linkText: link.linkText,
            linkUrl: link.linkUrl.destinationUrl,
            openInNewTab: link.openInNewTab,
            role: 'button',
            additionalProperties: attributes
        } as Msdyn365.ILinksData;
    });
};
